import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/home.vue';
import Synopsis from '@/views/synopsis.vue';
import Sell from '@/views/sell.vue';
import Buy from '@/views/buy.vue';
import User from '@/views/user.vue';
import Test from '@/views/test.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/synopsis',
    name: 'Synopsis',
    component: Synopsis,
  },
  {
    path: '/sell',
    name: 'Sell',
    component: Sell,
  },
  {
    path: '/buy',
    name: 'Buy',
    component: Buy,
  },
  {
    path: '/user',
    name: 'User',
    component: User,
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;